export default `{
  "headers": {
      'Accept-Language': 'en-US'
  }
}`